import { useState, useEffect, useCallback } from 'react'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type KeywordType = {
    userID: number | null
    recID?: string | null
}

export type FacultyDataListType = {
    facultyID: number
    facultyName: Translation
    rec: {
        id: number
        name: Translation
    }
}

type Translation = {
    th: string
    en: string
}

export const useSearchSettingFaculty = () => {
    const [dataList, setDataList] = useState<FacultyDataListType[]>([])

    const callApi = useCallApi()

    const searchSettingFaculty = useCallback(async (values?: KeywordType) => {
        if (values?.userID) {
            const url = new URL(umServiceURL.getSearchSettingFaculty)
            url.searchParams.set('userID', values.userID.toString())
            values.recID && url.searchParams.set('recID', values.recID)
            const { data } = await callApi.axiosGet({
                url,
            })

            setDataList(data)
        }
    }, [])

    useEffect(() => {
        searchSettingFaculty()
    }, [searchSettingFaculty])

    return {
        dataList,
        setDataList,
        searchSettingFaculty,
    }
}
